import styled from "styled-components";
import {Operation, useGetResultsSearchEmployeeBySearch} from "@mbj-front-monorepo/data-access";
import {MbjFlex, MbjLoading, MbjScrollArea, MbjWidgetClassic} from "@mbj-front-monorepo/ui";
import * as React from "react";
import {CardProfilFind} from "./CardProfilFind";
import {useMemo} from "react";

interface BlockResultEmployeeCtrlProps{
  className?:string;
  Search:Operation<"gETSearchsItem">
}

const BlockResultEmployeeCtrl = (props:BlockResultEmployeeCtrlProps)=>{
  const ResultsQuery = useGetResultsSearchEmployeeBySearch(props.Search.id||null)
  const ProfilsSauvegard = useMemo(()=>{
    if(ResultsQuery.data){
      return ResultsQuery.data?.sort((a, b) => (a.score || 0) > (b.score || 0) ? -1 : 1).filter(r => r.statut?.id === 2)
    } else {
      return []
    }
  }, [ResultsQuery.data])
  const ProfilsRejeteBut = useMemo(()=>{
    if(ResultsQuery.data){
      return ResultsQuery.data?.sort((a, b) => (a.score || 0) > (b.score || 0) ? -1 : 1).filter(r => r.statut?.id === 3 && ((r.scoreWhenStatut||0) > (r.score||0)))
    } else {
      return []
    }
  }, [ResultsQuery.data])
  return (
    <MbjWidgetClassic title={"Résultat de la recherche par profil"} basis={"100%"} className={`bl ${props.className}`}>

      {ResultsQuery.isLoading || ResultsQuery.isLoading ? (
        <MbjLoading />
      ) : ResultsQuery.isError || ResultsQuery.isError ? (
        <p>Erreur ...</p>
      ) : (
        <>
          {ResultsQuery.data.length === 0 ?
            <p className={"no-result"}>Malheureusement à l'heure actuelle, aucun profil ne correspond à votre recherche</p>:
            <>
              <div className={`one_block_result`}>
                  <div className={`nb_resultat`}>Nombre de profils compatibles : {ResultsQuery.data.filter(r=>r.statut?.id === 1).length}</div>
                  <MbjScrollArea maxHeight={"300px"} basis={"100%"}>
                  {ResultsQuery.data?.sort((a, b) => (a.score || 0) > (b.score || 0) ? -1 : 1).filter(r => r.statut?.id === 1).map((item, idx: number) => (
                    <CardProfilFind key={`one_result${idx}`} Employee={item.Employee} score={item.score} idSearch={item.id||0} idStatut={1}/>
                  ))}
                  </MbjScrollArea>
              </div>
              <div className={`one_block_result`}>
                {ProfilsSauvegard.length === 0 ?
                  <p className={"no-result"}>Vous n'avez pas encore retenu de profil</p>:
                  <>
                    <div className={`nb_resultat`}>Nombre de profils retenus : {ProfilsSauvegard.length}</div>
                    <MbjScrollArea maxHeight={"300px"}>
                      {ProfilsSauvegard.map((item, idx: number) => (
                        <CardProfilFind key={`one_result${idx}`} Employee={item.Employee} score={item.score} idSearch={item.id||0} idStatut={2}/>
                      ))}
                    </MbjScrollArea>
                  </>
                }
              </div>
              {ProfilsRejeteBut.length > 0 &&
                <div className={`one_block_result`}>
                  <div className={`nb_resultat`}>Profils rejetés mais qui ont progressé : {ProfilsRejeteBut.length}</div>
                  <MbjScrollArea maxHeight={"300px"}>
                    {ProfilsRejeteBut.map((item, idx: number) => (
                      <CardProfilFind key={`one_result${idx}`} Employee={item.Employee} score={item.score} idSearch={item.id||0} idStatut={3}/>
                    ))}
                  </MbjScrollArea>
                </div>
              }
            </>
          }
        </>
      )
      }

    </MbjWidgetClassic>
  )
}

export const BlockResultEmployee = styled(BlockResultEmployeeCtrl)`
  .one_block_result{
    width: 100%;
  }
  .nb_resultat{
    font-size: 18px;
    margin-bottom: 15px;
  }
`
